import React, { FC, ReactNode } from 'react';
import componentsId from '@src/constants/componentsId';

import styles from './LandingBenefitsLayout.module.scss';

type LandingBenefitsLayoutProps = {
  children: ReactNode;
};

const LandingBenefitsLayout: FC<LandingBenefitsLayoutProps> = ({ children }) => {
  return (
    <div className={styles.container_landing_benefits} id={componentsId.landingBenefitsSection}>
      {children}
    </div>
  );
};

export default LandingBenefitsLayout;
